<template lang="html">
	<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
		viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
		<g>
			<path style="fill:#F0C419;" d="M388.414,0c9.746,0,17.655,7.91,17.655,17.655s-7.91,17.655-17.655,17.655v141.241
				c0,64.177-45.656,117.654-106.24,129.801c0.106-0.018,0.203-0.026,0.309-0.044v37.967h8.828v44.138h17.655
				c9.746,0,17.655,7.91,17.655,17.655v17.655H185.379v-17.655c0-9.746,7.91-17.655,17.655-17.655h17.655v-44.138h8.828v-37.967
				c0.106,0.018,0.203,0.026,0.309,0.044c-60.584-12.147-106.24-65.624-106.24-129.801V35.31c-9.746,0-17.655-7.91-17.655-17.655
				S113.841,0,123.586,0H388.414z"/>
			<g>
				<path style="fill:#F29C1F;" d="M71.69,79.448v26.483c0,41.031,21.389,77.921,55.79,98.392c-1.88-9.19-2.825-18.476-2.825-27.772
					V79.448H71.69z M141.242,229.703c-1.086,0-2.18-0.203-3.231-0.618c-51.015-20.083-83.977-68.431-83.977-123.154v-35.31
					c0-4.882,3.946-8.828,8.828-8.828h70.621c4.882,0,8.828,3.946,8.828,8.828v105.931c0,13.903,2.436,27.825,7.247,41.366
					c1.156,3.257,0.3,6.894-2.18,9.295C145.7,228.838,143.493,229.703,141.242,229.703L141.242,229.703z"/>
				<path style="fill:#F29C1F;" d="M387.345,79.448v97.103c0,9.295-0.945,18.582-2.825,27.772
					c34.401-20.471,55.79-57.362,55.79-98.392V79.448H387.345z M370.758,229.703c-2.251,0-4.458-0.865-6.135-2.489
					c-2.481-2.401-3.337-6.038-2.18-9.295c4.811-13.542,7.247-27.463,7.247-41.366V70.621c0-4.882,3.946-8.828,8.828-8.828h70.621
					c4.882,0,8.828,3.946,8.828,8.828v35.31c0,54.722-32.962,103.071-83.977,123.154C372.938,229.5,371.844,229.703,370.758,229.703
					L370.758,229.703z"/>
				<path style="fill:#F29C1F;" d="M326.621,423.724H185.379v-17.655c0-9.746,7.91-17.655,17.655-17.655h105.931
					c9.746,0,17.655,7.91,17.655,17.655V423.724z"/>
			</g>
			<g>
				<polygon style="fill:#F0C419;" points="220.691,388.414 291.311,388.414 291.311,344.276 220.691,344.276 		"/>
				<path style="fill:#F0C419;" d="M256,308.966L256,308.966c-73.128,0-132.414-59.286-132.414-132.414V35.31h264.828v141.241
					C388.414,249.679,329.128,308.966,256,308.966"/>
			</g>
			<g>
				<path style="fill:#F29C1F;" d="M256,308.966c-9.066,0-17.92-0.918-26.483-2.657v37.967h52.966v-37.967
					C273.92,308.047,265.066,308.966,256,308.966"/>
				<path style="fill:#F29C1F;" d="M388.414,35.31H123.586c-9.746,0-17.655-7.91-17.655-17.655S113.841,0,123.586,0h264.828
					c9.746,0,17.655,7.91,17.655,17.655S398.159,35.31,388.414,35.31"/>
				<polygon style="fill:#F29C1F;" points="256,105.931 269.639,134.991 300.138,141.241 278.069,162.269 282.483,194.207 
					256,179.129 229.517,194.207 233.931,162.269 211.862,141.241 242.361,134.991 		"/>
			</g>
			<path style="fill:#CB8252;" d="M344.276,512H167.724v-70.621c0-9.746,7.91-17.655,17.655-17.655h141.241
				c9.746,0,17.655,7.91,17.655,17.655V512z"/>
			<g>
				<path style="fill:#805333;" d="M308.966,450.207c-4.882,0-8.828,3.946-8.828,8.828c0,4.882,3.946,8.828,8.828,8.828h35.31v-17.655
					H308.966z"/>
				<path style="fill:#805333;" d="M203.034,485.517c4.882,0,8.828-3.946,8.828-8.828c0-4.882-3.946-8.828-8.828-8.828h-35.31v17.655
					H203.034z"/>
			</g>
		</g>
  </svg>

</template>

<script>
export default {
  name: 'Trophy'
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/Trophy.vue